var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmPayoutRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0001 0.875C13.5093 0.875 0.875 13.5092 0.875 29C0.875 44.4908 13.5093 57.125 29.0001 57.125C44.4909 57.125 57.1251 44.4907 57.1251 29C57.1251 13.5093 44.4909 0.875 29.0001 0.875ZM29.0001 51.1886C16.779 51.1886 6.81137 41.2211 6.81137 29C6.81137 16.7789 16.7791 6.81137 29.0001 6.81137C41.2211 6.81137 51.1888 16.779 51.1888 29C51.1888 41.221 41.2213 51.1886 29.0001 51.1886ZM41.0074 19.7355C42.1848 20.913 42.1849 22.8395 41.0074 24.0168L26.9601 38.0641C26.1222 38.902 25.0455 39.2676 23.8706 39.1129C22.6957 38.9582 21.7502 38.3266 21.1577 37.3004L16.5127 29.2549C15.6801 27.8129 16.1788 25.952 17.6209 25.1193C19.0629 24.2868 20.9238 24.7854 21.7564 26.2275L24.8593 31.602L36.7258 19.7355C37.9032 18.5581 39.8298 18.5581 41.0073 19.7355H41.0074Z",
    fill: "url(#paint0_linear_11310_6612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11310_6612",
    x1: 29.0001,
    y1: 57.125,
    x2: 29.0001,
    y2: 0.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA49C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPayoutRequest);
export default __webpack_public_path__ + "static/media/ConfirmPayoutRequest.d71244de4354e1b9add1359f7c3e9ca4.svg";
export { ForwardRef as ReactComponent };